// extracted by mini-css-extract-plugin
module.exports = {"earningsWidgetRoot":"EDyevnOg"};